// extracted by mini-css-extract-plugin
module.exports = {"root":"InstructionStepsSection-module--root--dd6934","instructionSteps":"InstructionStepsSection-module--instructionSteps--258bdd"};